<!-- 项目文件 -->
<template>
  <div class="maxw960 mauto bgfff">
    <div class="pl16 pr16 pt30">
      <p class="fs26 c333">
        您的角色是?
      </p>
      <P class="fs16 c999 mt15 mb15">
        我们根据选择为您提供精准服务
      </P>

      <router-link to="/School/index">
        <div class="overflow mt15 mb15 be8 bradius8 pl15 pb15 pr15 pt15">
          <div class="floatl lh24">
            <p class="fs16 c333">我是驾校</p>
            <p class="fs12 c999">DRIVING SCHOOL</p>
          </div>
          <div class="floatr">
            <img class="w90 h60" src="../../public/img/img1.png" alt="">
          </div>
        </div>
      </router-link>


      <a href="https://m.yixueyijia.com/school_wap/wap/html/index.html">
        <div class="overflow mt15 mb15 be8 bradius8 pl15  pr15 pt15">
          <div class="floatl lh24 pb15">
            <p class="fs16 c333">我是学员</p>
            <p class="fs12 c999">STUDET</p>
          </div>
          <div class="floatr posre">
            <img class="w80 h76  verbot" src="../../public/img/img2.png" alt="">
          </div>
        </div>
      </a>


      <router-link to="/Partner/index">
        <div class="overflow mt15 mb15 be8 bradius8 pl15 pb15 pr15 pt15">
          <div class="floatl lh24">
            <p class="fs16 c333">我是合作伙伴</p>
            <p class="fs12 c999">PARTNERS</p>
          </div>
          <div class="floatr">
            <img class="w90 h60" src="../../public/img/img3.png" alt="">
          </div>
        </div>
      </router-link>
      

      
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {

            };
        },
        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>

</style>